<template>
  <div :class="`course-form-control ${error ? 'course-form-control--error' : ''}`">
    <label v-show="label">{{ label }}</label>
    <input :value="value"
           :type="type || 'text'"
           :name="name"
           :id="id"
           v-bind="$attrs"
           @blur="$emit('blur', $event.target.value)"
           @input="$emit('input', $event.target.value)"
           @change="$emit('change', $event.target.value)"
    />
    <span class="text-error" v-if="error">
      {{ error }}
    </span>
  </div>
</template>


<script>
export default {
  props: ['value', 'error', 'label',  'id', 'type', 'name'],
  emits: ['update:modelValue'],
}
</script>